import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
type ModalKey = 'terms' | 'privacy' | null;
export function Footer() {
  const [openModal, setOpenModal] = useState<ModalKey>(null);
  return <>
      <footer className="w-full bg-wine px-5 py-10 text-center text-white" data-id="element-64">
        <div className="mx-auto max-w-container" data-id="element-65">
          <p className="font-serif italic text-[16px] text-cream" data-id="element-66">
            Vitalízate Ahora
          </p>
          <nav className="mt-4" aria-label="Enlaces legales" data-id="element-67">
            <ul className="flex items-center justify-center gap-3 text-[12px] text-pinkLight" data-id="element-68">
              <li data-id="element-69">
                <button type="button" onClick={() => setOpenModal('terms')} className="transition-colors hover:text-white focus:outline-none focus-visible:text-white focus-visible:underline" data-id="element-70">
                  Términos
                </button>
              </li>
              <li aria-hidden="true" data-id="element-71">·</li>
              <li data-id="element-72">
                <button type="button" onClick={() => setOpenModal('privacy')} className="transition-colors hover:text-white focus:outline-none focus-visible:text-white focus-visible:underline" data-id="element-73">
                  Privacidad
                </button>
              </li>
            </ul>
          </nav>
          <p className="mt-5 text-[11px]" style={{
          color: '#ED93B1'
        }} data-id="element-74">
            © 2026 Vitalízate Ahora. Hecho con amor para mujeres latinas.
          </p>
        </div>
      </footer>

      <LegalModal open={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Términos y Condiciones" data-id="element-75">
        <p className="text-[12px] uppercase tracking-wider text-rose" data-id="element-76">
          Última actualización: Mayo 2026
        </p>

        <h3 className="mt-5 font-serif text-[16px] font-medium text-wine" data-id="element-77">
          1. Sobre este producto
        </h3>
        <p className="mt-2" data-id="element-78">
          "Menopausia en Equilibrio" es una guía digital (ebook en formato PDF)
          publicada por Vitalízate Ahora. Al completar tu compra, recibes acceso
          inmediato al material y a los bonos descritos en esta página.
        </p>

        <h3 className="mt-5 font-serif text-[16px] font-medium text-wine" data-id="element-79">
          2. Naturaleza informativa
        </h3>
        <p className="mt-2" data-id="element-80">
          El contenido es educativo e informativo. No sustituye consejo,
          diagnóstico ni tratamiento médico profesional. Si tienes una condición
          médica o tomas medicamentos, consulta siempre a tu doctor antes de
          aplicar cualquier recomendación.
        </p>

        <h3 className="mt-5 font-serif text-[16px] font-medium text-wine" data-id="element-81">
          3. Licencia de uso
        </h3>
        <p className="mt-2" data-id="element-82">
          Al adquirir la guía obtienes una licencia personal e intransferible.
          No está permitido revender, copiar, redistribuir ni compartir el
          contenido total o parcial sin autorización por escrito.
        </p>

        <h3 className="mt-5 font-serif text-[16px] font-medium text-wine" data-id="element-83">
          4. Pago y entrega
        </h3>
        <p className="mt-2" data-id="element-84">
          El pago se procesa a través de plataformas seguras. Tras confirmar la
          transacción recibirás un correo con el enlace de descarga en menos de
          2 minutos. Si no lo ves, revisa tu carpeta de spam o promociones.
        </p>

        <h3 className="mt-5 font-serif text-[16px] font-medium text-wine" data-id="element-85">
          5. Garantía y reembolso
        </h3>
        <p className="mt-2" data-id="element-86">
          Cuentas con 7 días desde la fecha de compra para solicitar reembolso
          completo, sin formularios ni preguntas. Pasado ese plazo, las ventas
          son finales.
        </p>

        <h3 className="mt-5 font-serif text-[16px] font-medium text-wine" data-id="element-87">
          6. Resultados
        </h3>
        <p className="mt-2" data-id="element-88">
          Los testimonios reflejan experiencias individuales. Los resultados
          dependen de tu organismo, constancia y circunstancias personales.
          Vitalízate Ahora no garantiza resultados específicos.
        </p>

        <h3 className="mt-5 font-serif text-[16px] font-medium text-wine" data-id="element-89">
          7. Cambios
        </h3>
        <p className="mt-2" data-id="element-90">
          Vitalízate Ahora puede actualizar estos términos en cualquier momento.
          La versión vigente es la publicada en este sitio.
        </p>
      </LegalModal>

      <LegalModal open={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-91">
        <p className="text-[12px] uppercase tracking-wider text-rose" data-id="element-92">
          Última actualización: Mayo 2026
        </p>

        <h3 className="mt-5 font-serif text-[16px] font-medium text-wine" data-id="element-93">
          1. Qué información recopilamos
        </h3>
        <p className="mt-2" data-id="element-94">
          Recopilamos únicamente los datos que tú nos proporcionas al comprar:
          nombre, correo electrónico y la información necesaria para procesar el
          pago a través de proveedores externos seguros.
        </p>

        <h3 className="mt-5 font-serif text-[16px] font-medium text-wine" data-id="element-95">
          2. Cómo usamos tus datos
        </h3>
        <p className="mt-2" data-id="element-96">
          Usamos tu información para entregar el producto, enviarte el enlace de
          descarga, brindar soporte relacionado con tu compra y, si lo
          autorizas, compartir contenido educativo de Vitalízate Ahora.
        </p>

        <h3 className="mt-5 font-serif text-[16px] font-medium text-wine" data-id="element-97">
          3. Pagos
        </h3>
        <p className="mt-2" data-id="element-98">
          No almacenamos los datos completos de tu tarjeta. Las transacciones se
          procesan mediante pasarelas certificadas que cumplen estándares PCI.
        </p>

        <h3 className="mt-5 font-serif text-[16px] font-medium text-wine" data-id="element-99">
          4. Cookies y analítica
        </h3>
        <p className="mt-2" data-id="element-100">
          Este sitio puede usar cookies y herramientas de analítica para mejorar
          la experiencia, medir el rendimiento del sitio y entender qué
          contenido te resulta útil. Puedes desactivarlas desde tu navegador.
        </p>

        <h3 className="mt-5 font-serif text-[16px] font-medium text-wine" data-id="element-101">
          5. Con quién compartimos información
        </h3>
        <p className="mt-2" data-id="element-102">
          No vendemos ni alquilamos tu información. Solo la compartimos con
          proveedores estrictamente necesarios para entregar el producto
          (procesador de pagos, plataforma de envío de correos) bajo acuerdos de
          confidencialidad.
        </p>

        <h3 className="mt-5 font-serif text-[16px] font-medium text-wine" data-id="element-103">
          6. Tus derechos
        </h3>
        <p className="mt-2" data-id="element-104">
          Puedes solicitar acceso, corrección o eliminación de tus datos
          personales en cualquier momento, así como darte de baja de
          comunicaciones con un solo clic en cualquier correo que te enviemos.
        </p>

        <h3 className="mt-5 font-serif text-[16px] font-medium text-wine" data-id="element-105">
          7. Seguridad
        </h3>
        <p className="mt-2" data-id="element-106">
          Aplicamos medidas técnicas razonables para proteger tu información.
          Ningún sistema en línea es 100% infalible, pero trabajamos para
          mantener tus datos seguros.
        </p>
      </LegalModal>
    </>;
}